export enum Role {
    ENGINEER = 'engineer',
    CUSTOMER = 'customer',
}
